import { defineComponent as _defineComponent } from 'vue'
import TradeCountReportDashboardWidget from '@/app/components/trades/widgets/TradeCountReportDashboardWidget.vue';
import CommissionCountReportDashboardWidget from '@/app/components/trades/widgets/CommissionCountReportDashboardWidget.vue';
import TransactionCountReportDashboardWidget from '@/app/components/trades/widgets/TransactionCountReportDashboardWidget.vue';
import MyAccountsDashboardWidget from '@/app/components/trades/widgets/MyAccountsDashboardWidget.vue';
import TopAccountsDashboardWidget from '@/app/components/trades/widgets/TopAccountsDashboardWidget.vue';
import { add } from 'date-fns';
import LastLoginInfo from '@/app/components/session/LastLoginInfo.vue';
import { ref } from 'vue';

interface DateObj {
  date: Date;
  title: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerDashboardView',
  setup(__props) {

const dates: DateObj[] = [
  { date: add(new Date(), { weeks: -1 }), title: 'Past week' },
  { date: add(new Date(), { months: -1 }), title: 'Past month' },
  { date: add(new Date(), { months: -3 }), title: 'Past 3 months' },
  { date: add(new Date(), { months: -6 }), title: 'Past 6 months' },
  { date: add(new Date(), { years: -1 }), title: 'Past year' },
];

const showDatesMenu = ref<boolean>(false);
const fromDateObj = ref<DateObj>(dates[0]);
const toDate = new Date();

function setDate(dateObj: DateObj) {
  fromDateObj.value = dateObj;
  showDatesMenu.value = false;
}

return { __sfc: true,dates, showDatesMenu, fromDateObj, toDate, setDate, TradeCountReportDashboardWidget, CommissionCountReportDashboardWidget, TransactionCountReportDashboardWidget, MyAccountsDashboardWidget, TopAccountsDashboardWidget, LastLoginInfo }
}

})